export function getProperty(obj, path) {
    const parts = path.split('.');
    var value = obj;

    for (const part of parts) {
        if (value === null || value === undefined) {
            return null;
        }
        value = value[part];
    }

    return value;
}